import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.commissions')
  .factory('ConsolidateCommissionsApi', ConsolidateCommissionsApi);

function ConsolidateCommissionsApi(): BringozApi {
  return {
    base: `/consolidatedCommission`,
    infiniteScroll: {
      address: `/consolidatedCommission`,
      cmd: 'GET'
    },
    actions: {
      getOne: {
        address: '{id}',
        cmd: 'GET',
        updateable: false
      },
      create: {
        address: '',
        cmd: 'PUT',
        updateable: false
      },
      update: {
        address: '{id}',
        cmd: 'POST',
        updateable: false
      },
      delete: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: false
      },
      addCommissions: {
        address: '{id}/addCommissions',
        cmd: 'POST',
        updateable: false
      },
      removeCommissions: {
        address: '{id}/removeCommissions',
        cmd: 'POST',
        updateable: false
      },
      payManually: {
        address: '{id}/payManually',
        cmd: 'POST',
        updateable: false
      },
      pay: {
        address: '{id}/pay',
        cmd: 'POST',
        updateable: false
      },
      exportTableCSV: {
        address: 'actions/export',
        cmd: 'POST',
        updateable: false
      },
      exportCSV: {
        address: '{id}/actions/extExport',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}
